// extracted by mini-css-extract-plugin
export var active = "x_bd";
export var column = "x_b5";
export var columns = "x_b4";
export var container = "x_b";
export var link = "x_bs";
export var title = "x_h";